import React from 'react';
import { translate } from 'react-i18next';
import Actions from 'accounts/components/list/AccountsActions';

const AccountsListRow = ({ account, company, subcompany, permissions, t, handleToggle }) => {
  return (
    <tr>
      <td>{account.key}</td>
      <td>{account.name}</td>
      <td>{account.description}</td>
      <td className="text-center">{t(account.active ? 'common.yes' : 'common.no')}</td>
      <td className="text-center">
        <Actions
          permissions={permissions}
          account={account}
          company={company}
          subcompany={subcompany}
          handleToggle={handleToggle}
        />
      </td>
    </tr>
  );
};

export default translate()(AccountsListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/list/AccountsListRow.js